import { post } from 'axios';
import cookie from 'react-cookies';
import API from '../../settings/api';
import { TARIFF_FEATURES } from '../../settings/tariff.features';

export function redirectIfTariffRequired(data) {

  if (!data || data.code !== 'tariff_required') return false;
  if (!Object.prototype.hasOwnProperty.call(TARIFF_FEATURES, data.feature)) return false;

  const next = `/tariff-required?feature=${encodeURIComponent(data.feature)}`;
  if (`${window.location.pathname}${window.location.search}` === next) return true;

  window.location.assign(next);
  return true;

}

export function formatRuDate(value) {

  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '';
  return `${match[3]}.${match[2]}.${match[1]}`;

}

export function formatRub(value) {

  const number = Number(value);
  if (!Number.isInteger(number) || number < 0) return '';
  return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

}

export function manualPaymentText(row) {

  if (!row || row.provider !== 'manual') return '';
  if (Number(row.amountRub) === 0) return 'Назначено без оплаты';
  if (Number(row.amountRub) > 0) return `Выдал администратор, сумма ${formatRub(row.amountRub)} ₽`;
  return '';

}

export function tariffStatusText(tariff) {

  if (!tariff || !tariff.name || tariff.state === 'none') return 'Тариф не подключён';

  const date = formatRuDate(tariff.endsAt);

  if (tariff.state === 'expired') return `Тариф: ${tariff.name}, закончился ${date}`;
  if (tariff.state === 'active') return `Тариф: ${tariff.name} до ${date}`;

  return 'Тариф не подключён';

}

function failureText(err, fallback) {

  if (typeof err === 'string' && err) return err;
  if (err?.message) return err.message;
  return fallback;

}

export async function own(store) {

  const token = cookie.load('token');

  try {

    const { status, data } = await post(API.tariff.own, {}, { headers: { token } });

    if (status !== 200 || !data?.success || !data?.tariff) {

      throw (data?.text || 'Не удалось загрузить тариф');

    }

    return { success: true, data };

  } catch (err) {

    console.error(err);
    return { success: false, text: failureText(err, 'Не удалось загрузить тариф') };

  }

}

export async function payments(store) {

  const token = cookie.load('token');

  try {

    const { status, data } = await post(API.tariff.payments, {}, { headers: { token } });

    if (status !== 200 || !data?.success || !Array.isArray(data?.payments)) {

      throw (data?.text || 'Не удалось загрузить историю');

    }

    return { success: true, payments: data.payments };

  } catch (err) {

    console.error(err);
    return { success: false, text: failureText(err, 'Не удалось загрузить историю') };

  }

}

export async function required(store, feature) {

  const token = cookie.load('token');

  try {

    const { status, data } = await post(API.tariff.required, { feature }, { headers: { token } });

    if (status !== 200 || !data?.success) {

      throw (data?.text || 'Не удалось проверить тариф');

    }

    return { success: true, data };

  } catch (err) {

    console.error(err);
    return { success: false, text: failureText(err, 'Не удалось проверить тариф') };

  }

}
